import projection from '../generated/pwm5m1f1.json';
import { AcceptanceManifest } from '../types';

export const pwm5m1f1AcceptanceManifest = projection as AcceptanceManifest;
